import React from "react";
import { useEffect, useRef } from "react";
import { VerticalTimeline } from "react-vertical-timeline-component";
import VerticalTimelineElement from "./VerticalTimeLineElementComponent";
import Grid from "@mui/material/Grid";
import "react-vertical-timeline-component/style.min.css";

const VerticalTimelineComponent = ({ timelineData }) => {
  const currentElement = useRef(null);

  //Scroll the Curr item into view
  useEffect(() => {
    if (currentElement?.current) {
      currentElement.current.scrollIntoView({
        block: "end",
      });
    }
  }, [currentElement]);

  return (
    timelineData.length > 0 && (
      <>
        <Grid container spacing={3}>
          <Grid item xs={12} marginTop={"50px"}>
            <VerticalTimeline
              padding="0"
              lineColor={"lightgrey"}
              layout="1-column-left"
            >
              {timelineData.map((data) => (
                <VerticalTimelineElement
                  key={data.Id}
                  elementData={data}
                  innerRef={
                    data.ReasonCode === "CURR" ? currentElement : undefined
                  }
                />
              ))}
            </VerticalTimeline>
          </Grid>
        </Grid>
      </>
    )
  );
};
export default VerticalTimelineComponent;
